var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-file',{attrs:{"multiple":"","name":"files","placeholder":"Escollir fitxers","drop-placeholder":"Deixa el fitxer aqui..."},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})
}
var staticRenderFns = []

export { render, staticRenderFns }